import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableEmptyStateComponent } from '@shared-modules/table-shared/_components';
import { AppRoutes } from '@shared/helpers';
import { ResultsDownloadApi } from 'src/app/features/orders/_shared/_core/api';
import { initializeDashboardOrderResultsTableColumns } from '../../_core/helpers';
import { DashboardService } from '../../_core/services/dashboard.service';
import { ResultsTableRowComponent } from './results-table-row/results-table-row.component';

@Component({
    selector: 'app-dashboard-results-table',
    standalone: true,
    imports: [TranslateModule, TableEmptyStateComponent, ResultsTableRowComponent, NgTemplateOutlet],
    templateUrl: './dashboard-results-table.component.html',
    styleUrls: ['./dashboard-results-table.component.scss'],
    providers: [ResultsDownloadApi],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardResultsTableComponent {
    readonly resultsList = computed(
        () => this.dashboardService.dashboardData().orderResultsData.ordersAndRetestsWithRecentResults
    );
    readonly orderSetupRoute = computed(() => AppRoutes.routes().ORDERS_SETUP);

    readonly columns = initializeDashboardOrderResultsTableColumns();

    constructor(private dashboardService: DashboardService) {}
}
